import {Component, OnInit} from '@angular/core';
import {DialogComponent, DialogService} from 'ng2-bootstrap-modal';
import _ from 'lodash';
import Dygraph from 'dygraphs';

export interface Model {
  title: string;
  data: string;
}

@Component({
  selector: 'app-dygraphs',
  templateUrl: './dygraphs.component.html',
  styleUrls: ['./dygraphs.component.css', '../../myreports.component.css']
})
export class DygraphsComponent extends DialogComponent<Model, any> implements OnInit {
  data: any;
  dg: any;
  public options: any = {
    height: $(window).height() * 0.75,
  };
  someRange = 100;
  sideSlideConfig = {
    step: 1,
    connect: true,
    range: {
      min: 10,
      max: 300
    },
    direction: 'rtl',
    orientation: 'vertical'
  };
  minValue: number;
  maxValue: number;

  constructor(dialogService: DialogService) {
    super(dialogService);
  }

  ngOnInit() {
    this.options = _.merge(this.data.options, this.options);
    if (document.getElementById('dygraph')) {
      this.dg = new Dygraph(document.getElementById('dygraph'), this.data.chartData, this.options);
      this.dg.ready(function () {
        this.resize();
      });
      this.data.updateRange(this, this.dg);
      this.data.remapDygraph({target:{value: this.data.feature}}, this.data, this.dg)
    }

    document.getElementsByTagName('body')[0].classList.add('modal-open');
  }

  onChange(event) {
    let max = this.maxValue * event / 100;
    this.dg.updateOptions({valueRange: [this.minValue, max]});
  }

}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/zoomView/dygraphs/dygraphs.component.ts